import { Layers01Icon } from '@hugeicons/core-free-icons';
import { createIcon } from '../icon';

export const Layers = /* @__PURE__ */ createIcon(Layers01Icon, 'Layers');
